export default "__VITE_ASSET__6a8767f5__"